import type { SVGProps } from "react";
export interface BellIndicatorIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BellIndicatorIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BellIndicatorIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3.376 13.131V9.5a8.625 8.625 0 0 1 10.282-8.465 1.125 1.125 0 1 1-.43 2.207A6.375 6.375 0 0 0 5.627 9.5v3.631c0 .94-.321 1.848-.903 2.575l-.265.302-.224.23a.375.375 0 0 0 .268.637H19.5c.29 0 .456-.306.337-.541l-.067-.096-.226-.23a4.13 4.13 0 0 1-1.168-2.877V11a1.125 1.125 0 0 1 2.25 0v2.131c0 .489.19.958.53 1.309l.226.23c1.619 1.663.44 4.455-1.882 4.455H4.503c-2.321 0-3.5-2.792-1.882-4.456l.225-.23.12-.137c.265-.331.41-.744.41-1.17ZM14 20.875l.115.005a1.126 1.126 0 0 1 0 2.239l-.114.006H10a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M20.875 4.5a1.376 1.376 0 1 0-2.752.001 1.376 1.376 0 0 0 2.752 0Zm2.25 0a3.625 3.625 0 1 1-7.25-.001 3.625 3.625 0 0 1 7.25.001"
      />
    </svg>
  );
}
